<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonalProfile.saveError">
    <template slot="center">
      <el-form label-width="20em" :model="formData" :ref="formRef">
        <section v-for="(section, key) in list" :key="key">
          <h4 class="section-title">{{ $t(`label.${key}`) }}</h4>
          <el-form-item :label="$t(`label.${item.key}`)" v-for="item in list[key].values" :key="item.key">
            <el-col class="el-col--min-25em" :span="12">
              <el-input :disabled="!edit" v-model="formData.PersonData[`${item.section}_${item.key}`].value" @blur="onInputBlur">
                <template slot="prepend" v-if="section.prefix">{{ section.prefix }}</template>
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col class="el-col--min-25em" :span="12">
              <hr v-if="!_isEmpty(list[key].values) && !_isEmpty(list[key].empty)" style="margin: 0">
            </el-col>
          </el-form-item>
          <el-form-item
             v-for="item in list[key].empty"
             v-if="_has(formData.PersonData, `${item.section}_${item.key}`, false)"
            :label="$t(`label.${item.key}`)"
            :key="item.key">
            <el-col class="el-col--min-25em" :span="12">
              <el-input :disabled="!edit" v-model="formData.PersonData[`${item.section}_${item.key}`].value" @blur="onInputBlur">
                <template slot="prepend" v-if="section.prefix">{{ section.prefix }}</template>
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item v-if="list[key].length > limit">
            <el-col class="el-col--min-25em" :span="12">
              <p class="ui-element horizontal-divider">
                <el-button type="text" size="mini" @click="showMoreOrLess(key)">
                  {{ showMore[key] ? $t('label.more') : $t('label.less') }}
                </el-button>
              </p>
            </el-col>
          </el-form-item>
          <p class="section-help" v-if="section.label">
            {{ $t(section.label) }}
          </p>
        </section>
      </el-form>
    </template>
    <template slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm">
            {{ $t('label.save') }}
        </el-button>

        <el-button type="text" size="small" @click="customCancelChanges(false)">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { omitBy, pick, pickBy, toArray, isNil, assign, each, slice } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

export default {
  name: 'form-my-prefferences-external-links',
  mixins: [FormStandardBehavior],
  props: {
    PersonalProfile: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
    saveError: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      limit: 3,
      showMore: {
        social_networks: true,
        online_contacts: true,
        personal_profile_pages: true,
      },
      list: {
        social_networks: {
          values: [],
          empty: [],
          length: 0,
          prefix: 'https://',
          helpLabel: '',
        },
        online_contacts: {
          values: [],
          empty: [],
          length: 0,
          prefix: '',
        },
        personal_profile_pages: {
          values: [],
          empty: [],
          length: 0,
          prefix: 'https://',
        },
      },
      formData: {
        PersonData: {
          social_networks_facebook: {
            section: 'social_networks',
            key: 'facebook',
            value: null,
          },
          social_networks_you_tube: {
            section: 'social_networks',
            key: 'you_tube',
            value: null,
          },
          social_networks_instagram: {
            section: 'social_networks',
            key: 'instagram',
            value: null,
          },
          social_networks_twitter: {
            section: 'social_networks',
            key: 'twitter',
            value: null,
          },
          social_networks_reddit: {
            section: 'social_networks',
            key: 'reddit',
            value: null,
          },
          social_networks_academia_edu: {
            section: 'social_networks',
            key: 'academia_edu',
            value: null,
          },
          social_networks_ask: {
            section: 'social_networks',
            key: 'ask',
            value: null,
          },
          social_networks_class_mates: {
            section: 'social_networks',
            key: 'class_mates',
            value: null,
          },
          social_networks_google: {
            section: 'social_networks',
            key: 'google',
            value: null,
          },
          social_networks_meetup: {
            section: 'social_networks',
            key: 'meetup',
            value: null,
          },
          social_networks_pinterest: {
            section: 'social_networks',
            key: 'pinterest',
            value: null,
          },
          social_networks_vine: {
            section: 'social_networks',
            key: 'vine',
            value: null,
          },
          social_networks_vk: {
            section: 'social_networks',
            key: 'vk',
            value: null,
          },
          online_contacts_skype: {
            section: 'online_contacts',
            key: 'skype',
            value: null,
          },
          online_contacts_viber: {
            section: 'online_contacts',
            key: 'viber',
            value: null,
          },
          online_contacts_whats_app: {
            section: 'online_contacts',
            key: 'whats_app',
            value: null,
          },
          online_contacts_talky: {
            section: 'online_contacts',
            key: 'talky',
            value: null,
          },
          online_contacts_oo_voo: {
            section: 'online_contacts',
            key: 'oo_voo',
            value: null,
          },
          online_contacts_we_chat: {
            section: 'online_contacts',
            key: 'we_chat',
            value: null,
          },
          online_contacts_slack: {
            section: 'online_contacts',
            key: 'slack',
            value: null,
          },
          online_contacts_google_hangouts: {
            section: 'online_contacts',
            key: 'google_hangouts',
            value: null,
          },
          personal_profile_pages_personal_web_site: {
            section: 'personal_profile_pages',
            key: 'personal_web_site',
            value: null,
          },
          personal_profile_pages_linked_in: {
            section: 'personal_profile_pages',
            key: 'linked_in',
            value: null,
          },
          personal_profile_pages_facebook_page: {
            section: 'personal_profile_pages',
            key: 'facebook_page',
            value: null,
          },
          personal_profile_pages_google_page: {
            section: 'personal_profile_pages',
            key: 'google_page',
            value: null,
          },
          personal_profile_pages_flickr: {
            section: 'personal_profile_pages',
            key: 'flickr',
            value: null,
          },
          personal_profile_pages_foursquare: {
            section: 'personal_profile_pages',
            key: 'foursquare',
            value: null,
          },
          personal_profile_pages_tumblr: {
            section: 'personal_profile_pages',
            key: 'tumblr',
            value: null,
          },
        },
      },
    };
  },
  methods: {
    showMoreOrLess(key) {
      this.showMore[key] = !this.showMore[key];
      this.populateEmptyList(key);
    },
    populateLists() {
      each(this.list, (item, key) => {
        this.populateEmptyList(key);
        this.populateValuesList(key);
      });
    },
    populateEmptyList(key) {
      const empty = pickBy(this.formData.PersonData, item => item.section === key && (isNil(item.value) || item.value === ''));
      const array = toArray(empty);
      this.list[key].length = array.length;
      this.list[key].empty = this.showMore[key] ? slice(array, 0, this.limit) : array;
    },
    populateValuesList(key) {
      const values = pickBy(this.formData.PersonData, item => item.section === key && !isNil(item.value) && item.value !== '');
      this.list[key].values = toArray(values);
    },
    onInputBlur() {
      // console.log('onInputBlur');
      this.populateLists();
    },
    getFormData() {
      const PersonData = omitBy(this.formData.PersonData, item => isNil(item.value));
      return { PersonData };
    },
    setFormData() {
      assign(this.formData.PersonData, pick(this.PersonalProfile.data.PersonData, [
        'social_networks_facebook', 'social_networks_you_tube', 'social_networks_instagram', 'social_networks_twitter', 'social_networks_reddit', 'social_networks_academia_edu', 'social_networks_ask', 'social_networks_class_mates', 'social_networks_google', 'social_networks_meetup', 'social_networks_pinterest', 'social_networks_vine', 'social_networks_vk', 'online_contacts_skype', 'online_contacts_viber', 'online_contacts_whats_app', 'online_contacts_talky', 'online_contacts_oo_voo', 'online_contacts_we_chat', 'online_contacts_slack', 'online_contacts_google_hangouts', 'personal_profile_pages_personal_web_site', 'personal_profile_pages_linked_in', 'personal_profile_pages_facebook_page', 'personal_profile_pages_google_page', 'personal_profile_pages_flickr', 'personal_profile_pages_foursquare', 'personal_profile_pages_tumblr',
      ]));
      this.populateLists();
    },
    customCancelChanges(validate) {
      this.cancelChanges(validate);
      this.populateLists();
    },
  },
  created() {
    this.stateData = this.PersonalProfile;
    this.formRef = 'form-my-prefferences-external-links';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/external-links/form-my-prefferences-external-links.vue